import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;

// Fetches the unauthenticated deployment config (/api/config/public) once and caches it.
export function usePublicConfig() {
  const [config, setConfig] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    api.get("/config/public")
      .then((r) => { _cache = r.data; setConfig(r.data); })
      .catch(() => setConfig({ product: "GovFlowState", is_demo: false, features: {} }));
  }, []);
  return config;
}
